import { RouteNames } from "src/routes/routeName";
import {
  Col,
  Result,
  Row,
} from "antd";
import TranslationKey from "src/i18n/translation";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function SuccessOrder() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  return (
    <>
      <Row className="mt-6 mb-4">
        <Col span={16} offset={4}>
          <Result
            status="success"
            title={TranslationKey('successOrder.successfullyPurchased')}
            subTitle={TranslationKey('successOrder.thanksYourFor')}
            className="result-order"
            extra={[
              <Link
                key="go-to-orders"
                to={RouteNames.orderHistory}
                replace
                className="btn-orange-round"
                style={{ textDecoration: "none" }}
              >
                {TranslationKey('successOrder.goToOrders')}
              </Link>
            ]}
          />
        </Col>
      </Row>
    </>
  );
}
